import React, { useState } from "react";
import { PAYMENT_STATUS } from "../utils/paymentStatus";

const TILES = [
  { key: "", label: "All contracts", pick: (s) => ({ count: s?.all?.count ?? 0, meta: null }) },
  {
    key: PAYMENT_STATUS.OVERDUE,
    label: "Overdue",
    fg: "var(--vz-danger)",
    pick: (s, fmt) => ({ count: s?.overdue?.count ?? 0, meta: `${fmt(s?.overdue?.amount_eur)} late` }),
  },
  {
    key: PAYMENT_STATUS.DUE_SOON,
    label: "Due in 30 days",
    fg: "var(--vz-warning)",
    pick: (s, fmt) => ({ count: s?.due_soon?.count ?? 0, meta: `${fmt(s?.due_soon?.amount_eur)} expected` }),
  },
  {
    key: PAYMENT_STATUS.UNSCHEDULED,
    label: "No due date",
    pick: (s) => ({ count: s?.unscheduled?.count ?? 0, meta: "needs scheduling" }),
  },
];

const Tile = ({ tile, active, count, meta, onClick }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: "pointer",
        background: active ? "var(--vz-light)" : "#fff",
        padding: "15px 18px",
        transition: "background 0.15s ease",
        ...(hovered && !active ? { background: "var(--vz-light)" } : {}),
      }}
    >
      <div
        className="text-uppercase text-muted"
        style={{ fontSize: 11.5, fontWeight: 600, letterSpacing: 0.6 }}
      >
        {tile.label}
      </div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 650,
          marginTop: 5,
          color: tile.fg || "inherit",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {count}
      </div>
      {meta && (
        <div className="text-muted" style={{ fontSize: 12.5, marginTop: 2 }}>
          {meta}
        </div>
      )}
    </div>
  );
};

/**
 * 4-tile summary row. Clicking a tile toggles the payment_status filter to
 * that bucket (re-clicking the active one, or clicking "All", clears it).
 * Counts/sums come from GET /contracts/stats/, computed over the
 * search/type/phase/year-filtered set — not further narrowed by whichever
 * tile is currently selected (see ContractViewSet.stats).
 */
const ContractStatTiles = ({ stats, paymentStatus, onSelect, formatCurrency }) => {
  const fmt = (v) => formatCurrency(v || 0, "EUR");

  return (
    <div
      className="border rounded-4 mb-3"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(148px, 1fr))",
        gap: 1,
        background: "var(--vz-border-color)",
        overflow: "hidden",
      }}
    >
      {TILES.map((tile) => {
        const { count, meta } = tile.pick(stats, fmt);
        const active = paymentStatus === tile.key;
        return (
          <Tile
            key={tile.key || "all"}
            tile={tile}
            active={active}
            count={count}
            meta={meta}
            onClick={() => onSelect(active ? "" : tile.key)}
          />
        );
      })}
    </div>
  );
};

export default ContractStatTiles;
